import { AnyAction } from 'redux';
import { defaultRange, descriptorsFactory, IJsonQuery } from '../../utils/filters';

const modifyValue = ({ floor = defaultRange }: IJsonQuery, action: AnyAction) => {
  return action ? Object.assign({}, floor.value, { [action.subType]: action.value }) : floor.value;
};

export const floorInputDescriptors = descriptorsFactory({ name: 'Floor', clear: [] })({
  form: [{ key: 'floor', type: 'range', value: modifyValue }],
  label: '',
  state: 'floor',
});
